import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FooterService } from '../../_services/site-footer/footer.service';
import { SubscribeService } from './subscribe.service';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss']
})
export class SiteFooterComponent implements OnInit {

  public showGDPR = true;
  subscribeForm: FormGroup;

  constructor(public footer: FooterService, private FormBuilder: FormBuilder,private subscribeService:SubscribeService) {
   this.addForm();
  }
  addForm(){
    this.subscribeForm = this.FormBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ]
    });
  }

  ngOnInit(): void {
    let item = localStorage.getItem("gdpr");
    if(item){
      this.showGDPR = false;
    }else{
      this.showGDPR = true;
    }
  }

  gdpr(): void{
    localStorage.setItem("gdpr", JSON.stringify({"allowed" : true}));
    this.showGDPR = false;
  }

 async submitForm(){
let email = this.subscribeForm.value.email;
console.log('email==>',email);

let mailResp:any = await this.subscribeService.getSubscribeMail(email).toPromise();
console.log('mailResp==>',mailResp);
this.addForm();

  }
}
